<div [formGroup]="sportSelectionForm">
  <mat-form-field appearance="outline" floatLabel="always" class="width-100-percent">
    <mat-label>Select sport</mat-label>
    <mat-select formControlName="sport_configuration_id">
      <mat-option [value]="item.id" *ngFor="let item of sportOptionList" (click)="onChangeSport(item.parent_id, item.parent_sport_id)">{{ item.name }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
